import { UsuarioList } from "../../../../../types/usuario/UsuarioList";

export interface AcessoInformacao {
  id?: string;
  documento?: string;
  nome: string;
  email: string;
  sexo: string;
  telefone: string;
  categoria: string;
  formatoContato: string;
  observacao: string;
  dataHoraCriacao?: Date | string;
  anonimo?: boolean;
}
export const ISacessoInformacao: AcessoInformacao = {
  id: '',
  categoria: '',
  documento: '',
  nome: '',
  email: '',
  sexo: '',
  telefone: '',
  formatoContato: '',
  observacao: '',
  dataHoraCriacao: '',
  anonimo: false
};
export interface AcessoInformacaoList {
  id: string;
  categoria: string;
  documento?: string;
  nome: string;
  email: string;
  sexo: string;
  telefone: string;
  anonimo?: boolean;
  formatoContato: string;
  observacao: string;
  dataHoraCriacao?: Date | string;
  arquivado?: boolean;
  resposta?: string;
  usuarioResposta?: UsuarioList | null;
  dataHoraResposta?: Date | string;
}
export const ISacessoInformacaoList: AcessoInformacaoList = {
  id: '',
  categoria: '',
  documento: '',
  nome: '',
  email: '',
  sexo: '',
  telefone: '',
  formatoContato: '',
  observacao: '',
  anonimo: false,
  dataHoraCriacao: '',
  arquivado: false,
  resposta: '',
  usuarioResposta: null,
  dataHoraResposta: ''
};

export interface AcessoInformacaoDTO {
  id: string;
  idCategoria: string;
  documento?: string;
  nome: string;
  email: string;
  sexo: string;
  telefone: string;
  anonimo?: boolean;

  formatoContato: string;
  observacao: string;
}
export const ISacessoInformacaoDTO: AcessoInformacaoDTO = {
  id: '',
  idCategoria: '',
  documento: '',
  nome: '',
  email: '',
  sexo: '',
  telefone: '',
  formatoContato: '',
  observacao: '',
  anonimo: false
};

export interface AcessoInformacaoRespostaDTO {
  id: string;
  resposta: string;
}
export const ISacessoInformacaoRespostaDTO: AcessoInformacaoRespostaDTO = {
  id: '',
  resposta: ''
};

export interface AcessoInformacaoLoginResponse {
  id: string;
  login: string;
  senha: string;
}
export const ISacessoInformacaoLoginResponse: AcessoInformacaoLoginResponse = {
  id: '',
  login: '',
  senha: ''
};

export interface AcessoInformacaoLogin {
  login: string;
  senha: string;
}
export const ISacessoInformacaoLogin: AcessoInformacaoLogin = {
  login: '',
  senha: ''
};

export interface AcessoInformacaoListPublicResponse {
  results: AcessoInformacaoList[];
  count: number;
  next: string | null;
  previous: string | null;
}
